export const selectApplications = (state) => state.app.app;
